import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpResponse<any>> {
    return next.handle(req).pipe<HttpResponse<any>>(
      map((event: HttpResponse<any>) => {

        if (event['body']) {
          // Check if the response has the expected status
          if (!event['body'].status) {
            throw new HttpResponse<any>({ body: event['body'].message || 'Unknown error' });
          }
          // Modify the body to include only the data part
          return new HttpResponse<any>({ body: event['body'].data });
        }
        return event;
      })
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/response.interceptor.ts